import { Box, Typography, useTheme } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';

function OverallSkillRating({ value }) {
  const theme2 = useTheme();

  let color = 'primary';
  if (value > 0) {
    color = theme2.palette.success.main;
  }

  return (
    <Box
      sx={{
        width: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: -1,
      }}
      textAlign="center">
      <Gauge
        value={value}
        text={({ value: gValue }) => `${gValue}%`}
        startAngle={0}
        endAngle={360}
        innerRadius="110%"
        outerRadius="140%"
        valueMin={0}
        valueMax={100}
        width={60}
        height={60}
        sx={() => ({
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: 15,
          },
          [`& .${gaugeClasses.valueArc}`]: {
            fill: color,
          },
        })}
      />
      <Typography
        sx={{ marginTop: -0.2 }}
        textAlign="center"
        fontWeight={500}
        variant="body2"
        color="tertiary.main">
        Match
      </Typography>
    </Box>
  );
}

export default OverallSkillRating;
